import axios from "axios";
import instance,{BASE_URL} from "../../services/api";
import toast from 'react-hot-toast';

const LeaveViewController =() =>{
  const getErrorMessage = (error) => {
  return (
    error.response?.data?.detail ||   // Django REST Framework style
    error.response?.data?.message ||  // custom backend message
    error.response?.data?.error ||    // another fallback
    error.message ||                  // Axios default
    "Something went wrong!"
  );
};
    const getLeaves = () => async (dispatch) => {
        dispatch({ type: "LOADING", payload: true });
        try {
          const response = await instance.get(`${BASE_URL}leave/request/`);
    
          const jsonString = JSON.stringify(response.data);
          const data = JSON.parse(jsonString);
          dispatch({ type: "GET_LEAVES_SUCCESS", payload: data });
          dispatch({ type: "LOADING", payload: false });
        } catch (error) {
          dispatch({ type: "LOADING", payload: false });
          const message = getErrorMessage(error);
          dispatch({
            type: "GET_LEAVES_FAILURE",
            payload: { error: error }
          });
          toast.error(message);
        }
      };

  const addLeaves = (reqData) => async (dispatch) => {
  dispatch({ type: "LOADING", payload: true });

  const authToken = localStorage.getItem("access_token");

  const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${authToken}`,
    },
  });

  try {
    // // convert reqData into FormData
    // const formData = new FormData();
    // for (const key in reqData) {
    //   formData.append(key, reqData[key]);
    // }

    const response = await axiosInstance.post("leave/request/",reqData);
    const data = response.data;

    dispatch({ type: "ADD_LEAVES_SUCCESS", payload: data });
    dispatch(getLeaves());
    toast.success("Leave applied successfully");
  } catch (error) {
    dispatch({
      type: "ADD_LEAVES_FAILURE",
      payload: { error },
    });
    // Optional: extract backend error message
    // const message = getErrorMessage(error);
    // toast.error(message);
  } finally {
    dispatch({ type: "LOADING", payload: false });
  }
};

    const updateLeaveStatus = (leaveId,newStatus) => async(dispatch) =>{
      dispatch({ type: "LOADING", payload: true });
      try {
        const response = await instance.put(`${BASE_URL}leave/${leaveId}/`,{
          approval_status: newStatus,
        });
  
        const jsonString = JSON.stringify(response.data);
        const data = JSON.parse(jsonString);
        dispatch({ type: "UPDATE_LEAVE_SUCCESS", payload: data });
        dispatch(getLeaves())
        dispatch({ type: "LOADING", payload: false });
      } catch (error) {
        dispatch({ type: "LOADING", payload: false });
        const message = getErrorMessage(error);
        dispatch({
          type: "UPDATE_LEAVE_FAILURE",
          payload: { error: error }
        });
        toast.error(message);
      }
   }; 
    
    const getLeaveBalance =() => async(dispatch)=>{
      dispatch({ type: "LOADING", payload: true });
      try {
        const response = await instance.get(`${BASE_URL}leave-balance/`);
  
        const jsonString = JSON.stringify(response.data);
        const data = JSON.parse(jsonString);
        dispatch({ type: "GET_LEAVEBALANCE_SUCCESS", payload: data });
        dispatch({ type: "LOADING", payload: false });
      } catch (error) {
        dispatch({ type: "LOADING", payload: false });
        const message = getErrorMessage(error);
        dispatch({
          type: "GET_LEAVEBALANCE_FAILURE",
          payload: { error: error }
        });
        toast.error(message);
      }    
    };

    const addLeaveBalance = (reqData) => async(dispatch) =>{
      dispatch({ type: "LOADING", payload: true });
      try {
      const response = await instance.post(`${BASE_URL}leave-balance/`,reqData);

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "ADD_LEAVEBALANCE_SUCCESS", payload: data });
      dispatch(getLeaveBalance())
      dispatch({ type: "LOADING", payload: false });
      return data;
      } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
      type: "ADD_LEAVEBALANCE_FAILURE",
      payload: { error: error }
      });
      toast.error(message);
      }
   };
    
  const updateLeaveBalance = (employeeId,reqData) => async(dispatch) =>{
    dispatch({ type: "LOADING", payload: true });
    try {
    const response = await instance.post(`${BASE_URL}leave-balance/${employeeId}/`,reqData);

    const jsonString = JSON.stringify(response.data);
    const data = JSON.parse(jsonString);
    dispatch({ type: "UPDATE_LEAVEBALANCE_SUCCESS", payload: data });
    dispatch(getLeaveBalance())
    dispatch({ type: "LOADING", payload: false });
    } catch (error) {
    dispatch({ type: "LOADING", payload: false });
    const message = getErrorMessage(error);
    dispatch({
    type: "UPDATE_LEAVEBALANCE_FAILURE",
    payload: { error: error }
    });
    toast.error(message);
    }
 };

 
  

   
    return{
        getLeaves, addLeaves,updateLeaveStatus,getLeaveBalance, addLeaveBalance, updateLeaveBalance,
       
    };
};

export default LeaveViewController;